import { footerStyles } from "@insite/content-library/Pages/Footer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

footerStyles.page = {
    css: css`
        max-width: none !important;
        background-color: #6A6A6A;
        border-top: 10px solid ${getColor("secondary.main")}
    `,
};
